export const inputAuthor = "Autore";
export const inputCognome = "Cognome*";
export const inputConfermaPassword = "Conferma Password*";
export const inputDescription = "Descrizione";
export const inputEmail = "Email*";
export const inputEmailLogin = "Email";
export const inputISBN = "ISBN";
export const inputLocks = "Privati";
export const inputNome = "Nome*";
export const inputNuovaPassword = "Nuova Password*";
export const inputPassword = "Password";
export const inputPasswordAttuale = "Password attuale*";
export const inputRole = "Ruolo";
export const inputSearch = "Cerca";
export const inputSelectedItemsLabel = "Elementi selezionati";
export const inputShared = "Condivisi";
export const inputState = "Stato";
export const inputTopic = "Topic";
export const inputTutti = "Tutti";
export const inputUsername = "Username";
